<div
  *ngIf="!isNoData"
  class="channel-opportunity">
  <div class="row">
    <div class="d-flex flex-auto justify-content-end filter" *ngIf="!isExportingPdfReport">
      <achoo-filter-box [options]="industryList"
                        name="industry"
                        placeholder="{{'measure.industries' | translate}}"
                        [(model)]="industryIndex"
                        (selectEvent)="selectIndustry(industryIndex)">
      </achoo-filter-box>
    </div>
  </div>
  <div class="row channel-opportunity-content">
    <div class="col-sm-6"
      *ngFor="let item of opportunityData; let i = index">
      <div class="content-box">
        <div class="d-flex flex-row flex-auto">
          <div class="d-flex flex-column flex-auto">
            <span class="percent">{{item.percent | percentNumberSuffix}} of {{item.value | formatNumberToString}}</span>
            <p class="subtitle">{{item.text}}</p>
            <div class="progress-bar-content">
              <div
                class="percent-progress-bar {{item.name}}"
                [ngStyle]="{'background-color': item.name === 'reach' ? reachLineColor : engageLineColor}"
                [style.width.%]="calculatePercent(item.percent)">
              </div>
            </div>
          </div>
          <div *ngIf="i < opportunityData.length - 1" class="oppo-left-seperation-line"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="isNoData && period !== 30"
  class="message">
  <span>{{'measure.only_30_day_supported' | translate}}</span>
</div>

<div
  *ngIf="isNoData && period === 30"
  class="message">
  <span>{{'measure.noData' | translate}}</span>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/channel-opportunities-report/channel-opportunities-report.component.html